import React from 'react';

/**
 *
 * PluginIcon
 *
 */

import { Globe } from '@strapi/icons';

const PluginIcon = () => <Globe width={20} height={20} />;

export { PluginIcon };
